import { UploadProps, message } from 'antd';
import { API_URL } from '../../utils/Constants';

export const PROPS: UploadProps = {
  name: 'file',
  showUploadList: false,
  accept: '.csv',
  action: API_URL + 'AiTrainer/upload',

  onChange(info) {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`файл ${info.file.name} успешно загружен`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} произошла ошибка.`);
    }
  },
};
